'use client';
import Image from 'next/image';
import CaretIcon from 'components/icons/CaretIcon';
import UIButton from 'components/buttons/UIButton';
import {
  captureConversationStarted,
  capturePlanBrowseStarted,
} from 'lib/analytics';

const HomepageHero = () => {
  return (
    <section className="hero homepage-hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="homepage">
            Let&apos;s find Medicare coverage that&apos;s the right fit for you.
          </h1>
          <div
            className="homepage-hero-content"
            role="group"
            aria-label="Options for getting started"
          >
            <div className="homepage-hero-card homepage-hero-card--alex">
              <div className="homepage-hero-card-text">
                <h2>ALEX® does the math so you don&apos;t have to.</h2>
                <p>
                  Answer a few easy questions and ALEX will talk you through
                  everything—your options, your costs, and a personalized
                  recommendation that&apos;s built around your preferences.
                </p>
              </div>
              <UIButton
                buttonType="primary"
                label="Get started"
                icon={
                  <CaretIcon direction="right" color="current" size="large" />
                }
                href="/check-audio"
                className="homepage-hero-btn"
                data-testid="landing-cta-help-me-pick"
                onClick={() => captureConversationStarted('homepage')}
              />
            </div>
            <div className="homepage-hero-card homepage-hero-card--browse">
              <div className="homepage-hero-card-text">
                <h2>Prefer to compare plans on your own?</h2>
                <p>Feel free to check out plans available in your area.</p>
              </div>
              <UIButton
                buttonType="secondary"
                label="Browse plans by ZIP Code"
                icon={
                  <CaretIcon
                    direction="right"
                    color="darkPurple"
                    size="large"
                  />
                }
                href="/browse/plans"
                className="homepage-hero-btn"
                onClick={() => capturePlanBrowseStarted('homepage')}
              />
            </div>
          </div>
        </div>
        <div className="hero-image-container">
          <Image
            src="/homepage/hero-map-3x.png"
            width={627}
            height={518}
            alt="Medicare enrollment map covering eligibility, doctor coverage, and costs"
            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
            sizes="(max-width: 768px) 100vw, 50vw"
            priority
          />
        </div>
      </div>
    </section>
  );
};

export default HomepageHero;
